// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.heading-title[data-v-62237580] {\n  background-color : #4CAF50;\n  width: 100%;\n  padding : 30px 0;\n}\n.heading-title__text__main[data-v-62237580] {\n  font-size : 60px;\n  color :white;\n  font-family: 'Tahoma', 'Meiryo';\n}\n.heading-title__text__sub[data-v-62237580] {\n  font-size : 16px;\n  font-weight: 500;\n  color :white;\n  margin-top: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
